import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  variant?: 'elevated' | 'flat' | 'interactive';
  className?: string;
  onClick?: () => void;
}
export function Card({
  children,
  variant = 'elevated',
  className = '',
  onClick
}: CardProps) {
  const baseStyles = 'rounded-xl overflow-hidden bg-surface transition-colors';
  const variants = {
    elevated: 'shadow-lg shadow-gray-200/50 dark:shadow-black/20 border border-border/50',
    flat: 'border border-border',
    interactive: 'shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-border/50'
  };
  const Component = onClick ? motion.div : 'div';
  return (
    // @ts-ignore - framer motion types can be tricky with dynamic components
    <Component className={`${baseStyles} ${variants[variant]} ${className}`} onClick={onClick} {...onClick ? {
      whileTap: {
        scale: 0.98
      }
    } : {}} data-id="element-92">
      {children}
    </Component>
  );
}